import  {type MatrixClient} from 'matrix-js-sdk'

/**
 * Convert an mxc:// URL to an HTTP(S) URL for rendering.
 * Optionally request a server-side thumbnail at the given dimensions.
 */
export function mxcToHttp(
  client: MatrixClient,
  mxcUrl: string | undefined,
  width?: number,
  height?: number,
  resizeMethod: string = 'scale',
): string | null {
  if (!mxcUrl) return null
  return client.mxcUrlToHttp(
    mxcUrl,
    width,
    height,
    resizeMethod,
    false, // allowDirectLinks
    false, // allowRedirects
    true, // useAuthentication
  )
}

/**
 * Get the full download URL for an mxc:// URI (no resizing).
 */
export function mxcToHttpDownload(
  client: MatrixClient,
  mxcUrl: string | undefined,
): string | null {
  if (!mxcUrl) return null
  return client.mxcUrlToHttp(
    mxcUrl,
    undefined,
    undefined,
    undefined,
    false,
    false,
    true,
  )
}
